import API from '../api.js'
import DataProcessor from '@lib/processors/data-processor'

class ClaimApiProcessor extends DataProcessor {
  constructor(params = {}) {
    const { path, headers } = params
    super(params)

    if (typeof path !== 'string' || path.length === 0) {
      throw Error('api-processor requires "path" key')
    }

    this.path = path
    this.headers = headers || null
    this.init()
  }

  destroy() {
    super.destroy()
  }

  getSortMap({ sort }) {
    const sortMap = {} // 'order[propName]: asc|desc'

    for (const key in sort) {
      if (sort.hasOwnProperty(key)) {
        sortMap[`order[${key}]`] = sort[key]
      }
    }

    return sortMap
  }

  getFiltersMap({ filters }) {
    return filters.reduce((acc, f) => {
      const { attribute, comparison, value } = f
      let paramKey = attribute

      if (comparison !== 'eq' && comparison !== 'select') {
        if (comparison === 'partial') {
          paramKey += '_partial'
        } else {
          paramKey += `[${comparison}]`
        }
      }

      acc[paramKey] = value

      return acc
    }, {})
  }

  sendRequest(dataQuery) {
    const { page, pageSize } = dataQuery

    const params = {
      page,
      perPage: pageSize,
      ...this.getSortMap(dataQuery),
      ...this.getFiltersMap(dataQuery),
    }

    if (process.env.VUE_APP_TAG === 'ICS') {
      params['_ts'] = +new Date()
    }

    return API.get(this.path, {
      params,
      headers: this.headers,
    }).then(([_, data]) => {
      const { items, pagination } = data

      return {
        data: items,
        total: pagination.total_items,
      }
    })
  }

  sendRequestAll() {
    const params = {
      page: 1,
      perPage: 1e9,
      ...this.getSortMap(),
      ...this.getFiltersMap(),
    }

    if (process.env.VUE_APP_TAG === 'ICS') {
      params['_ts'] = +new Date()
    }

    return API.get(this.path, {
      params,
      headers: this.headers,
    }).then(([_, data]) => {
      const { items, pagination } = data

      return {
        data: items,
        total: pagination.total_items,
      }
    })
  }
}

export default ClaimApiProcessor
